import { render } from "./SideDrawer.vue?vue&type=template&id=7a41222e&scoped=true&ts=true"
import script from "./SideDrawer.vue?vue&type=script&lang=ts"
export * from "./SideDrawer.vue?vue&type=script&lang=ts"

import "./SideDrawer.vue?vue&type=style&index=0&id=7a41222e&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a41222e"]])

export default __exports__